import PropTypes from 'prop-types';

const TeamAvailabilityDefaultProps = {
  totalAvailableHours: null,
  treatmentMinutesRequired: null,
  TreatmentsCount: null,
  relevantDate: null,
};

const TeamAvailabilityPropType = PropTypes.shape({
  totalAvailableHours: PropTypes.number,
  treatmentMinutesRequired: PropTypes.number,
  TreatmentsCount: PropTypes.number,
  relevantDate: PropTypes.instanceOf(Date),
});

export default { TeamAvailabilityDefaultProps, TeamAvailabilityPropType };
